/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { VisuallyHidden } from '@coursera/cds-core';

type Props = {
  color?: string;
  padding?: '--cds-spacing-50' | '--cds-spacing-100';
};

const styles = {
  dot: (color?: string, padding = '--cds-spacing-100') => css`
    padding: 0 var(${padding});
    color: ${color ?? 'inherit'};
  `,
  // display: block forces JAWS to insert a virtual buffer line break,
  // preventing number concatenation (e.g. "1" + "6" → "16").
  srBreak: css`
    display: block;
  `,
};

/**
 * A visual dot separator between content items.
 * The dot is hidden from screen readers via aria-hidden.
 * A visually hidden block-level element forces JAWS to insert a virtual
 * buffer line break between adjacent text, preventing number
 * concatenation (e.g. "Course 1" + "6 hours" → "Course 16 hours").
 */
const DottedSeparator = ({ color, padding }: Props) => {
  return (
    <React.Fragment>
      <span aria-hidden="true" css={styles.dot(color, padding)}>
        &#x2022;
      </span>
      <VisuallyHidden component="span" css={styles.srBreak}>
        {'\u00A0'}
      </VisuallyHidden>
    </React.Fragment>
  );
};

export default DottedSeparator;
